import { createAction } from '@ngrx/store';
import { LogoConfig } from '@/app/_core/domain/models/logo/logo.model';

export const enum LogoActionsTypes {
  SetLogo = '[Logo] Set Logo'
}

export const setLogo = createAction(LogoActionsTypes.SetLogo, ({ logo }: { logo: LogoConfig }) => ({
  payload: { logo }
}));
